<app-selector [label]="name" [isMultiple]="isMultiple" [isEmptySelectable]="isEmptySelectable" [data]="musicCoreService.musicList$ | async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="musicCoreService.loading$ | async" [hint]="hint">
</app-selector>
